import { LinkService } from '../types'

export function checkVideoLink(url: any): Promise<boolean> {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(false)
    }
    const video = document.createElement('video')
    video.src = url
    video.addEventListener('canplaythrough', () => {
      resolve(true)
    })
    video.addEventListener('error', () => {
      reject(false)
    })
  })
}

export const getLinkServiceDisplayName = (service: LinkService) => {
  const SERVICES = {
    youtube: 'YouTube',
    vimeo: 'Vimeo',
    matterport: 'Matterport',
    eyexpo: 'Eyexpo',
    metareal: 'Metareal',
    youriguide: 'iGUIDE'
  }

  return SERVICES[service] || ''
}

export const getYoutubeThumbnail = (url: string) => {
  const regex = new RegExp(
    /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*?[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/,
    'gi'
  )
  const videoId = url.match(regex)?.[0].split('/')[1].replace('watch?v=', '') || null
  return videoId ? `https://img.youtube.com/vi/${videoId}/0.jpg` : null
}

export const getVimeoThumbnail = async (url: string) => {
  const regex = /vimeo\.com\/(?:.*\/)?(\d+)/
  const match = url.match(regex)
  if (!match) return null
  const videoId = match[1]

  try {
    const response = await fetch(`https://vimeo.com/api/v2/video/${videoId}.json`)
    const data = await response.json()
    return data[0].thumbnail_medium
  } catch (error) {
    console.error('Error fetching Vimeo thumbnail:', error)
    return null
  }
}

export const getMatterportThumbnail = (url: string) => {
  const regex = /(?:\/space\/|[?&]m=)([a-zA-Z0-9]+)/
  const match = url.match(regex)
  const modelId = match ? match[1] : null
  return modelId ? `https://my.matterport.com/api/v1/player/models/${modelId}/thumb` : null
}

export const getMetarealThumbnail = (url: string) => {
  const regex = /[?&]asset=([^&]+)/
  const match = url.match(regex)
  const tourId = match ? match[1] : null
  return tourId ? `https://tour.metareal.com/view/asset/${tourId}/res/loading-screen.jpeg` : null
}
